export enum UserRole {
  Student = 'student',
  Teacher = 'teacher',
  Admin = 'admin',
  SuperAdmin = 'super-admin',
  RegionManager = 'region-manager',
  AccountManager = 'account-manager',
  Guest = 'guest',
}
